export default __webpack_public_path__ + "static/media/loading_bg_default.d43c5fdc.jpg";